import { invoke } from '@shared/easyfy.decorators';
import ProductListComponent from '../product/productlistcomponent';

@invoke
export default class MediaProductListComponent {
  static Instance: MediaProductListComponent;

  async onInit() {
    ProductListComponent.refreshProductList(false, true); //initialize slider if any
  }
}
